import React, { Fragment, useEffect } from "react";
import Calendar from "react-calendar";
import {
  PlusCircleIcon,
  XMarkIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import CustomDropdown from "../../../dropdown/CustomDropdown";
import IconButton from "../../../iconButton";
import { useGetTwilioChatTokenMutation } from "../../../../store/authTwilioToken";
import { createTwilioClient } from "../../../dashboard/twilio/api";
import { useLeadAssignedToProfessionalMutation } from "../../../../store/leadFlow";
import { useLeadAssignedToProfessionalAdminMutation } from "../../../../store/admin/matchesInfo";
import { useState } from "react";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../modal/ConfirmationModal";

const UnmatchedProfessionalSlideOver = ({
  show,
  setShowSlide,
  handleClose,
  lead_id,
}) => {
  let clientInstance;
  const [userID_OR_userEmail, setUserID_OR_userEmail] = useState("");
  const [twilioToken] = useGetTwilioChatTokenMutation();
  const [errorMessage, setErrorMessage] = useState("");
  const [isShowModal , setIsShowModal]=useState(false);
  const [isShowConfirmLoader , setIsShowConfirmLoader]=useState(false)

  const [
    saveAssignLeadToProfession,
    {
      isLoading: saveAssignLeadIsLoading,
      isSuccess: saveAssignLeadIsSuccess,
      data: assignedLeadData,
      isError: assignLeadIsError,
      error: assignLeadError,
    },
  ] = useLeadAssignedToProfessionalAdminMutation();

  const handleCloseConfirmation =()=>{
    
    setIsShowModal(false)
  }

  const handleCloseSlider = ()=>{
    handleClose()
    setUserID_OR_userEmail("")
  }

  const createTwilioConversation = async (matchInfo, clientInstance) => {
    const params = {
      match_id: matchInfo.match_id,
    };
    const newTwilioToken = await twilioToken(params).unwrap();
    const token = newTwilioToken.token;
    clientInstance = await createTwilioClient(token, matchInfo.match);
  };

  const initTwilioClient = async () => {
     await createTwilioConversation(
      assignedLeadData,
      clientInstance
    );
    toast.success(assignedLeadData.message);
    handleCloseSlider();
  };

  useEffect(() => {
    if (
      saveAssignLeadIsSuccess &&
      !saveAssignLeadIsLoading &&
      assignedLeadData
    ) {
      if (assignedLeadData.match_id) {
        initTwilioClient();
      } else {
        console.log("Missing match id in response");
      }
    } else if (assignLeadIsError) {
      if(assignLeadError.data.message == "Professional does not have enough credits")
      {
        setIsShowModal(true)
      }
      else {
        toast.error(assignLeadError.data.message);
      }
    }else{
      console.error('Something is missing')
    }
    return () => {
      if (clientInstance) {
        clientInstance.removeAllListeners();
        clientInstance.shutdown();
      }
    };
  }, [saveAssignLeadIsSuccess, assignLeadIsError]);

  const assignLeadToProfession = async () => {
    if (!userID_OR_userEmail) {
      setErrorMessage("ID field is required.");
      return;
    }
    if (userID_OR_userEmail && lead_id) {
      const params = {
        user_id: parseInt(userID_OR_userEmail),
        lead_id: lead_id,
      };
      saveAssignLeadToProfession(params);
    }
  };

  const handleChange = (event) => {
    if (event.target.value != "") {
      setErrorMessage("");
    }
    setUserID_OR_userEmail(event.target.value);
  };

  const confirmLeadAssign =()=>{
    setIsShowConfirmLoader(true)
  }

  return (
    <>
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleCloseSlider}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="">
                      <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                        <div className="flex items-center justify-between mb-2 md:mb-5">
                          <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                            Assign to Professional
                          </Dialog.Title>
                          <XMarkIcon
                            className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                            onClick={handleCloseSlider}
                          />
                        </div>
                        <p className="text-sm md:text-base font-normal leading-[160%] text-[#485868]">
                        Enter the User ID of the Professional
                        </p>
                      </div>
                      <form className="scroller max-h-[220px] md:max-h-[300px] overflow-y-auto pr-1 mb-[30px] dark-field">
                        <div>
                          {/* <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-[10px] md:mb-3 inline-block">
                            ID
                          </label> */}
                          <input
                            className="text-sm font-bold leading-[160%] uppercase text-customGray py-[10px] px-5 h-12 md:h-[70px] border border-solid border-strokeColor bg-white rounded-md w-full placeholder:lowercase placeholder:text-[#A7AFB7]"
                            placeholder="ex.#00000"
                            onChange={handleChange}
                            type="email"
                          />
                          {errorMessage && (
                            <p className="text-red-500 absolute text-xs leading-[160%] font-bold mt-1 ml-1">
                              {errorMessage}
                            </p>
                          )}
                        </div>
                      </form>
                      <div className="grid grid-cols-12 gap-5">
                        <IconButton
                          title="CANCEL"
                          icon={XCircleIcon}
                          classes="col-span-6 mb-5 md:mb-0 flex items-center bg-[#EBEFF3] text-sm md:text-base text-[#485868] rounded-[10px] font-black uppercase text-[#485868] leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer"
                          onClick={handleCloseSlider}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                        <IconButton
                          title="CONFIRM"
                          icon={CheckCircleIcon}
                          buttonLoader={saveAssignLeadIsLoading}
                          disabled={saveAssignLeadIsLoading}
                          classes="col-span-6 mb-5 md:mb-0 flex items-center bg-primary text-sm md:text-base text-white rounded-[10px] font-black uppercase text-[#485868] leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer"
                          onClick={assignLeadToProfession}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>

    </Transition.Root>
          <ConfirmationModal
          isOpen={isShowModal}
          handleClose={()=>handleCloseConfirmation()}
          handleConfirm={()=>confirmLeadAssign()}
          deleteLoader={isShowConfirmLoader}
          heading={"Confirm Credit Deduction"}
          text={"Would you like to charge credits to the professional being matched?"}
         />
         </>
  );
};

export default UnmatchedProfessionalSlideOver;
